module.exports = __webpack_public_path__ + "img/Logo-33.c266c901.svg";